import '@adornis/bh-matching-export/components/buddy-page-export.js';
import { BuddyPageExport } from '@adornis/bh-matching-export/components/buddy-page-export.js';
import { getMenteeUserClass, getMentorUserClass } from '@adornis/bh-matching-matches/user-class.js';
import type { BuddyUser } from '@adornis/bh-matching-user/entities/buddy-user.js';
import '@adornis/buchungsheld-components/bh-breadcrumb.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import type { DataViewOptions } from '@adornis/data-view/client/data-view-options.js';
import { openPopupWithLoadingScreen } from '@adornis/print/client/safe-popup.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { MentoringUserAPI } from '../../api/user.js';
import { MentoringDialogPrepareExport } from '../components/mentoring-dialog-prepare-export.js';

@customElement('mentoring-page-export')
export class MentoringPageExport extends BuddyPageExport {
  protected override actionRow(dataOptions: DataViewOptions<typeof BuddyUser>): Renderable[] {
    return [
      html`
        <tr-button
          icon="download"
          @click=${() => {
            const timeframe = this.currentTimeframe.value;

            MentoringDialogPrepareExport.showPopup({
              props: {
                dataOptions,
                timeframe,
                userClass: getMenteeUserClass(),
              },
            });
          }}
        >
          ${this.translator.translate('buddy', 'exportMenteeUser')}
        </tr-button>
        <tr-button
          icon="download"
          @click=${() => {
            const timeframe = this.currentTimeframe.value;

            MentoringDialogPrepareExport.showPopup({
              props: {
                dataOptions,
                timeframe,
                userClass: getMentorUserClass(),
              },
            });
          }}
        >
          ${this.translator.translate('buddy', 'exportMentorUser')}
        </tr-button>
      `,
      html` <slot name="additional-buttons"></slot> `,
      html`
        <tr-flex slot="additional-buttons" horizontal space="md">
          <tr-button
            icon="upload_file"
            @click=${async () => {
              const timeFrame = this.currentTimeframe.value;
              if (!timeFrame) return;

              openPopupWithLoadingScreen(
                MentoringUserAPI.downloadCurriculumVitaes(timeFrame, dataOptions.view?.filter)(),
              );
            }}
          >
            ${this.translator.translate('buddy', 'exportCurriculumVitae')}
          </tr-button>
        </tr-flex>
      `,
    ];
  }
}
